package fr.frux.shared.domain.model

/** Catégorie d'un retour utilisateur (#437, ADR 0028). */
enum class FeedbackCategory { BUG, IDEA, OTHER }

/**
 * Ce que la personne écrit, et d'où. La version de l'app et la plateforme sont jointes par le
 * repository, jamais saisies. [sourceScreen] est un identifiant stable (`profile`), pas un libellé.
 */
data class FeedbackDraft(
    val category: FeedbackCategory,
    val message: String,
    val sourceScreen: String,
)
